import React, { useEffect, useState } from 'react';
import { PagingQuery, Button } from 'tea-component';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/NewzooDetailFilter';
import { useIntl, connect } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import GamesCard from './GamesCard';
import { getMAUGamesCardData } from './_utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import { getDeviceConfig } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStatsMAU = (porps: any) => {
  const {
    tabId,
    filterState,
    companyId,
    entityType,
    gameName,
    setMainLoading,
    mainLoading,
    setDownloadParamsNormal,
    downloadParamsNormal,
  } = porps;

  const deviceDefVales = getDeviceConfig('MAU', entityType)?.value;
  const deviceOptions = getDeviceConfig('MAU', entityType)?.options;

  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [gameTableLoading, setGameTableLoading] = useState(false);
  const [gameChartLoading, setGameChartLoading] = useState(true);
  const [gameChartType, setGameChartType] = useState<string>('bar');
  const [gameTotal, setGameTotal] = useState<number>(0);
  const [gameTableList, setGameTableList] = useState<any>([]);
  const [gameLineList, setGameLineList] = useState<any>([]);
  const [gameBarOrPieList, setGameBarOrPieList] = useState<any>([]);
  const [gameCardStats, setGameCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const { companyMAUList } = useCompanyOptionList();
  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);

  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    entity_type: entityType,
    data_sources: ['newzoo'], // 固定
    order_metric: 'mau',
    order: 'desc',
    page: 1,
    page_size: 5,
    region_type: 'region',
    regions: ['global'],
    period: 'month', // 目前固定，仅有月粒度
    start_date: '',
    end_date: '',
    metrics: [
      'mau', // 固定
    ],
    device: deviceDefVales,
  });

  useEffect(() => {
    if (companyId && !filterLoading) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getGamesCardData(newFetchParams);
    }
  }, [companyId, filterLoading]);

  const formatRegionParams = (markets: string[]) => {
    // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues;
  };

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];
    if (timeExtend?.granularity === 'monthly') {
      // newFetchParams.period = timeExtend?.granularity;
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }

    if (marketExtend) {
      const regionValues = formatRegionParams(marketExtend?.markets);
      newFetchParams.region_type = regionValues?.regionType || 'market';
      newFetchParams.regions = regionValues?.regions;
    }
    return newFetchParams;
  };

  const getGamesCardData = async (params) => {
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      setGameCardStats({
        ...gameCardStats,
        isLoading: true,
      });
      setMainLoading(true);
      setDownloadParamsNormal(params);
      const gameData = await getMAUGamesCardData(params, tabId);
      const { startDate, endDate, cardStats, lineData, tableData, total, barOrPieData } = gameData;

      setDownloadParamsNormal({
        ...params,
        start_date: startDate,
        end_date: endDate,
      });
      setGameCardStats(cardStats);
      setGameBarOrPieList(barOrPieData);
      setGameLineList(lineData);
      setGameTableList(tableData);
      setGameTotal(total);

      const updatedFetchParams: any = updateDefaultTimeParams({
        fetchParams: params,
        startDate,
        endDate,
        period: params.period,
        isTwoMonths: false,
      });
      setFetchParams(updatedFetchParams);
      setMainLoading(false);
    }
  };
  const handleConfirm = (value: any) => {
    const newFetchParams = {
      ...fetchParams,
      ...value,
      period: value.date_type,
    };
    getGamesCardData(newFetchParams);
  };

  const onGameTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getMAUGamesCardData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onGameTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getMAUGamesCardData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            isTopCompanies
            hasDevice={entityType === 'console'}
            timeFilterValues={{
              type: fetchParams.period,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            onFilterInit={onFilterInit}
            deviceDefVales={deviceDefVales}
            deviceOptions={deviceOptions}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={entityType}
            mainLoading={mainLoading}
            downloadParamsNormal={downloadParamsNormal}
            gameName={gameName}
            segpaVa={entityType}
            segment={'mau'}
          />
        </div>
      </div>
      <GamesCard
        lineData={gameLineList}
        tableData={gameTableList}
        barOrPieList={gameBarOrPieList}
        dateType={fetchParams?.period}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        cardStatus={gameCardStats}
        tableTotal={gameTotal}
        columnsList={companyMAUList}
        tableLoading={gameTableLoading}
        onTableSortChage={onGameTableSortChage}
        onTablePagingChange={onGameTablePagingChange}
        entityType={entityType}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
        chartType={gameChartType}
        setChartType={setGameChartType}
        gameName={gameName}
      />
    </>
  );
};
export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(GamesStatsMAU);
